import { handleActions } from "redux-actions";
import Immutable from "immutable";
import {
  SET_ALL_TASKS,
  SET_TASK_SELECTED,
  SET_FILTER_SELECTED,
  SET_FORM_SELECTED,
  SHOULD_RELOAD_TASKS,
  SET_ARCHIVE_RECENTLY,
  ARCHIVE_TASKS,
  SET_FORMS_FROM_API,
  CREATE_NEW_TASK,
  SIGN_TASK,
  REMOVE_TASK,
  SET_TASKS_STATUS,
  SET_TASK_PAGE,
  SET_TASK_COUNT,
  SET_TASKLOG_COUNT,
  SET_TASKLOG_PAGE,
  GET_LOG_GROUPS_TASKS,
  SET_FORMS_LOADED,
  SET_FORMS_LOADED_END,
  SET_FORMS_EMPTY,

} from "../constants/actions";
/*import { Actions } from "react-native-router-flux";*/

import StorageService from "../services/storage";

const initialState = {
  tasks: [],
  taskSelected: {},
  formSelected: {},
  filter: "All",
  taskCreated: {},
  reload: false,
  archiveRecently: false,
  formList:[],
  lastUpdated: null,
  status: "idle",
  currentPage: 1,
  tasksCount: 0,
  pageSize: 10,
  currentLogPage:1,
  taskLogCount:0,
  logPageSize:5,
  taskLogTotal:null,
  formsLoaded: false,
  formsLoadedEnd: false
};


export default handleActions(
  {
    [SET_FORMS_LOADED]: (state, action) => {
      return state.set("formsLoaded", action.payload) 
    },
    [SET_FORMS_LOADED_END]: (state, action) => {
      return state.set("formsLoadedEnd", action.payload) 
    },
    [SET_FORMS_EMPTY]: (state, action) => {
      return state.set("formList", []);
    },
    [SET_TASKLOG_PAGE]: (state, action) => {
      return state.set("currentLogPage", action.payload);
    },
    [SET_TASKLOG_COUNT]: (state,action) => {
      return state.set("taskLogCount", action.payload);
    },
    [SET_TASK_PAGE]: (state, action) => {
      return state.set("currentPage", action.payload);
    },
    [SET_TASK_COUNT]: (state,action) => {
      return state.set("tasksCount", action.payload);
    },
    [SET_TASKS_STATUS]: (state, action) => {
      return state.set("status", action.payload);
    },
    [SET_ALL_TASKS]: (state, action) => {
      //   StorageService.set("tasks", action.payload);
      const dateNow = new Date();
      
      return state.set("tasks", action.payload)
      .set("lastUpdated",dateNow)
      .set("status",'idle');
    },
    [SET_TASK_SELECTED]: (state, action) => {
      return state.set("taskSelected", action.payload);
    },
    [SET_FILTER_SELECTED]: (state, action) => {
      return state.set("filter", action.payload);
    },
    [SET_FORM_SELECTED]: (state, action) => {
      return state.set("formSelected", action.payload);
    },
    [SHOULD_RELOAD_TASKS]: (state, action) => {
      return state.set("reload", action.payload);
    },
    [SET_ARCHIVE_RECENTLY]: (state, action) => {
      return state.set("archiveRecently", action.payload);
    },
    [ARCHIVE_TASKS]: (state, action) => {
      return state;
    },
    [SET_FORMS_FROM_API]: (state, action) => {
      const formList = state.get("formList");
      let ob = action.payload.forms;
      ob.map((item) => {
        item.isSelected = false;
        return item;
      });
      if (formList.hasOwnProperty("size")) {
        return state.set("formList", [...ob]);
      } else {
        return state.set("formList", [...formList, ...ob]); 
      }
    },
    [CREATE_NEW_TASK]: (state, action) => {
      return state.set("taskCreated", action.payload)
      .set("taskSelected",action.payload);
    },
    [SIGN_TASK]: (state, action) => {
      return state.set("tasks", action.payload);
    },
    [REMOVE_TASK]: (state,action)=> {
      return state.set("tasks",action.payload);
    },
    [GET_LOG_GROUPS_TASKS]: (state,action)=> {
      console.log('task number => '+action.payload)
      return state.set("taskLogTotal",action.payload);
    },
  },
  Immutable.fromJS(initialState)
);
